
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|2628|3946|7588|8499|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
